import { useState, useEffect } from "react";
import axios from "axios";
import BandPhotosTab from "./BandPhotosTab";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

export default function MediaKitConcertPhotosTab() {
  const [photos, setPhotos] = useState([]);

  const fetchPhotos = async () => {
    const res = await axios.get(`${API}/music/concert-photos`).catch(() => ({ data: [] }));
    setPhotos(res.data);
  };

  useEffect(() => { fetchPhotos(); }, []);

  return <BandPhotosTab photos={photos} onRefresh={fetchPhotos} endpoint="/music/concert-photos" />;
}
